import { bunja } from 'bunja';

import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import { SessionStorageKey, deleteSessionStorage, getSessionStorage } from '@flipster/utils/sessionStorage';

export const rootPopupBunja = bunja(() => {
  bunja.effect(() => {
    const authErrorMessage = getSessionStorage(SessionStorageKey.AuthErrorMessage);
    if (authErrorMessage) {
      if (authErrorMessage === 'api.authBlocked') {
        dialog.open({
          title: {
            label: 'Account suspended',
          },
          content: 'Currently, you are unable to Log in.\nPlease contact customer support for more information.',
          buttons: {
            primary: (
              <Dialog.Button
                hierarchy='primary'
                label='Contact Support'
                onClick={() => {
                  window.location.href = zendesk.getUrl('RequestNew');
                }}
              />
            ),
          },
        });
      } else {
        dialog.open({
          title: {
            label: 'Notice',
          },
          content: 'Looks like your session expired.\nPlease log in again.',
          buttons: {
            primary: <Dialog.Button hierarchy='primary' label='Confirm' />,
          },
        });
      }
      deleteSessionStorage(SessionStorageKey.AuthErrorMessage);
    }
    return () => {};
  });

  return {};
});
rootPopupBunja.debugLabel = 'rootPopupBunja';
